import { memo } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Nav from './Nav';

const Layout = memo(() => {
  return (
    <div className="min-h-full">
      <Nav />
      <main>
        <div className="flex flex-1 flex-col lg:pl-64">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
});

export default Layout;
